/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Popover, Position, Size, Tooltip } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store" 
import updateHistory from "../../utils/updateHistory"
import { ID } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface IItemEditorProps {
   item: any
   cards: any[]
   i: number
   type: string
   sectionId?: ID
   cardsMeatId?: ID
}
const ItemEditor = (props: IItemEditorProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null)
    const currentLanding                = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const [ sectionId, setSectionId ]   = useState<string>("")
    const [ dataId, setDataId ]         = useState<string>("") 

    useEffect(() => {
        const par = ref.current! as HTMLDivElement
        setSectionId( props.sectionId?.toString() || par.closest(".landing-section-container.landing-gap")?.getAttribute("id") || "" )
        setDataId( props.cardsMeatId?.toString()  || par.closest(`[data-type="${props.type}"][data-content-id]`)?.getAttribute("data-content-id") || "" )
    }, [ props.sectionId, props.cardsMeatId ])

    
    //console.log( sectionId, dataId, )
    
    const duplicate = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Duplicate card"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((s: ILandingSection) => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const cards: any[] = data.cards
                            const newItem = { 
                                ...props.item,
                                id: getID("image"),
                            }
                            cards.splice( props.i, 0,newItem )
                            if(data.id === dataId) {
                                return { ...data, cards }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    }

    const doDelete = () => {
        
        console.log(sectionId)
        console.log(dataId)
        
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Delete card"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((s: ILandingSection) => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const cards: any[] = data.cards
                            cards.splice( props.i, 1 ) 
                            if(data.id === dataId) {
                                return { ...data, cards }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    }
    const onPrev = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Swap cards"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const cards: any[] = data.cards
                            const newItems = cards.splice( props.i, 1 ) 
                            cards.splice( props.i - 1, 0, newItems[0] ) 
                            if(data.id === dataId) {
                                return { ...data, cards }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    }
    const onNext = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Swap cards"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const cards: any[] = data.cards
                            const newItems = cards.splice( props.i, 1 ) 
                            cards.splice( props.i + 1, 0, newItems[0] ) 
                            if(data.id === dataId) {
                                return { ...data, cards }
                            }
                            return step.data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    }
    const onAdd = (value: string ) => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Add cardcard"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const cards: any[] = data.cards 
                            const newItem = {
                                id: getID("card"), 
                                src: value
                            }
                            cards.splice( props.i + 1, 0, newItem ) 
                            if(data.id === dataId) {
                                return { ...data, cards }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    } 

    return <div className='pe-item-editor pe-surface' ref={ref}> 
        {
            props.i > 0 && <Tooltip
                position={Position.TOP_LEFT}
                content={__("Switch previous")}
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID}  onClick={onPrev}>
                    <Icon icon="arrow-left" size={12} />
                </Button>
            </Tooltip>
        }
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Duplicate")}
        >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={duplicate}>
                <Icon icon="duplicate" size={12} />
            </Button>
        </Tooltip>
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Add")}
        >
            <Popover
                content={ <AddItem onAdd={ onAdd } /> }
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} >
                    <Icon icon="plus" size={12} />
                </Button>
            </Popover>
        </Tooltip>
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Delete")}
        >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={doDelete}>
                <Icon icon="trash" size={12} />
            </Button>
        </Tooltip>
        {
            props.i < props.cards.length - 1 && <Tooltip
                position={Position.TOP_LEFT}
                content={__("Switch next")}
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={onNext}>
                    <Icon icon="arrow-right" size={12} />
                </Button>
            </Tooltip>
        }
    </div>
}
export default ItemEditor

export const AddItem = ({ onAdd }: any) => {
    const [value, setValue] = useState<any>("")
    return <div className="p-3">
        <FieldInput
            type={SCALAR_TYPES.MEDIA}
            editable
            value={value}
            onChange={(val: any) => setValue(val)}
        />
        <Button onClick={ () => onAdd( value ) } >
            {__("Add new item")}
        </Button>
    </div>
}